import useFlag from './useFlag';

const FLAG = 'consumer-experience.reservable-time-picker';

export function useReservableTimePickerEnabled() {
  const isEnabled = useFlag<boolean>(FLAG, false);

  return Boolean(isEnabled);
}
